import {
  deleteApiDonationsByUserIdDonationsDonationid,
  getApiDonationsByDate,
  getApiDonationsByUser,
  getApiDonationsByUserId,
} from '@/shared/api'
import { createMutation, createQuery } from '@farfetched/core'

export const donationsByUser = createQuery({
  handler: getApiDonationsByUser,
})
export const donationsByDate = createQuery({
  handler: getApiDonationsByDate,
})
export const donationsByUserId = createQuery({
  handler: getApiDonationsByUserId,
})
export const donationDelete = createMutation({
  handler: deleteApiDonationsByUserIdDonationsDonationid,
})
